import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Row.css";
import Youtube from "react-youtube";
import movieTrailer from "movie-trailer";
import { Link, Redirect } from "react-router-dom";
import { propTypes } from "react-bootstrap/esm/Image";

const base_url = " https://image.tmdb.org/t/p/original/";

function Row({ tittle, fetchUrl, isLargeRow, history }) {
  const [movies, setMovies] = useState([]); // empty movie array
  const [trailerUrl, setTrailerUrl] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const request = await axios.get(fetchUrl);
      setMovies(request.data.results);
      return request;
    };
    fetchData();
  }, [fetchUrl]); // if [], run once when the row loads , and dont run again

  const opts = {
    height: "390",
    width: "100%",
    playerVars: {
      autoplay: 1,
    },
  };

  const handleClick = (movie) => {
    console.log(movie);
    // if (trailerUrl) {
    //   console.log(movie);
    //   setTrailerUrl("");
    // } else {
    //   movieTrailer(movie?.name || "")
    //     .then((url) => {
    //       const urlParams = new URLSearchParams(new URL(url).search);
    //       setTrailerUrl(urlParams.get("v"));
    //     })
    //     .catch((error) => console.log(error));
    // }
  };

  return (
    <div className="row">
      {/* tittle*/}
      <h2>{tittle}</h2>

      <div className="row__posters">
        {movies.map((movie) => (
          <img
            key={movie.id}
            onClick={() => history.push(`/moviedetail/${movie.id}`)}
            className={`row__poster ${isLargeRow && "row__posterLarge"}`}
            src={`${base_url}${
              isLargeRow ? movie.poster_path : movie.backdrop_path
            }`}
            alt={movie.name}
          />
        ))}
      </div>
      {/* {trailerUrl && <Youtube videoId={trailerUrl} opts={opts} />} */}

      {/* container -> poster*/}
    </div>
  );
}

export default Row;
